import CompanyLocationsTab from "./company-locations-tab";

export default CompanyLocationsTab;